export default __webpack_public_path__ + "static/media/user-feed1.7b1ac311.png";